import React, { useEffect, useState } from 'react';
import MultiLineChart from './charts/MultiLineChart';

function CMDensityChart({ start, end }) {
  const [data, setData] = useState([]);

  useEffect(() => {
    const params = start && end
      ? `?start=${encodeURIComponent(start)}&end=${encodeURIComponent(end)}`
      : '';
    fetch(`/api/cm-density-daily.php${params}`)
      .then(res => res.json())
      .then(res => setData(res || []))
      .catch(() => setData([]));
  }, [start, end]);

  const labels = data.map(r => {
    const d = new Date(r.date);
    return d.toLocaleDateString('en-GB');
  });

  const autoVals = data.map(r => r.auto);
  const manualVals = data.map(r => r.manual);

  return (
    <MultiLineChart
      height={140}
      labels={labels}
      datasets={[
        { label: 'CM Density', data: autoVals, color: '#ff3333' },
        { label: 'Manual Density', data: manualVals, color: '#22c55e' },
      ]}
      showLegend={true}
      tickStep={0.5}
      yLabel="Density"
    />
  );
}

export default CMDensityChart;
